var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.0059C13.75 12.5247 12.5188 13.7559 11 13.7559C9.48124 13.7559 8.25002 12.5247 8.25002 11.0059C8.25002 9.48712 9.48124 8.2559 11 8.2559C12.5188 8.2559 13.75 9.48712 13.75 11.0059Z",
    stroke: "#9997AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25342 11.0059C3.4215 7.28687 6.89593 4.58923 11.0004 4.58923C15.1049 4.58923 18.5794 7.2869 19.7474 11.0059C18.5794 14.7249 15.1049 17.4226 11.0004 17.4226C6.89593 17.4226 3.42148 14.7249 2.25342 11.0059Z",
    stroke: "#9997AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show_password.fffaef435c144597c3510e2b6e419c5d.svg";
export { ForwardRef as ReactComponent };